import '../main.less';
import React from 'react';
import { Field, reduxForm } from 'redux-form';

import Checkbox from '../../../../shared/form-elements/checkbox';

const Form = props => {

	return (
		<div className="payout-request-form-wrap payouts-form-in-modal">
			<form
				className="ui-form payouts-form__main clearfix display-flex-column"
				onSubmit={props.handleSubmit(() => {})}
			>
				<div className="payout-request-form__main-fields">
					<div className="ui-form__element">
						<Field
							name="is_hidden_copy"
							placeholder={props.intl('Hide copy cols')}
							component={Checkbox}
						/>
					</div>
				</div>
			</form>
		</div>
	);
};

export default reduxForm({ form: 'createPayoutRequestToggleCopyForm' })(Form);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payout-requests/components/forms/toggle-copy-form/main.js